import { z } from "zod/v4"
import { useEffect, useState } from "react"
import useFetch from "@/hooks/use-fetch"
import { checkCiudad } from "../api/check-ciudad"
import { Alert, CircularProgress, Collapse } from "@mui/material"
import { Form, FormProps } from "@/components/form";
import { getDepartamento } from "../../departamentos/api/get-departamento"
import { getAllDepartamentos } from "../../departamentos/api/get-all-departamentos"


export const editCiudadFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    codigo: z.string().nonempty("Este campo es requerido"),
    departamentoId: z.string().nonempty("Este campo es requerido"),
})

export default function EditCiudadForm({
    form,
    ...props
}: FormProps<z.infer<typeof editCiudadFormSchema>>) {
    const [defaultDocumento, setDefaultDocumento] = useState<string>("");
    const [currentDocumento, setCurrentDocumento] = useState<string>("");

    const updateCurrentDocumento = (value: string) => {
        setCurrentDocumento(value);
        if (value.trim()) fetch(value);
    }

    const { fetch, value, loading } = useFetch(async (value: string) => {
        if (value) return await checkCiudad(value);
        return undefined;
    }, { debounceMs: 500 });

    const ciudadExists = (value !== null && value !== undefined) && (defaultDocumento !== currentDocumento); 
    
    useEffect(() => {
        setDefaultDocumento(form.options.defaultValues?.codigo ?? "");
    }, [])

    return <Form form={form} gap={3} {...props}>
        <Collapse in={ciudadExists} sx={{ marginY: "-10px" }}>
            <Alert severity={"warning"}>
                Ya existe una ciudad con ese código. No se pueden repetir códigos.
            </Alert>
        </Collapse>
        <Form.TextField name="codigo" label="Código" onChange={e => updateCurrentDocumento(e.target.value)}
            slotProps={{ input: { endAdornment: loading && <CircularProgress size={20} /> } }} />

        <Form.TextField name="nombre" label="Nombre" />
        <Form.ModelComboBoxAsync name="departamentoId" label="Departamento" get={getDepartamento} getAll={getAllDepartamentos} />
        <Form.SubmitButton disabled={ciudadExists}>Guardar</Form.SubmitButton>
    </Form>
}